<div class="trials-details product-detail-container">
  <app-tvshop-header [titleKey]="'eos-tv-shop-ii.title.trial-header'"></app-tvshop-header>

  <div class="product-detail-content" #trialcontent>
    <div class="intro-background" [ngStyle]="{ 'background-image': 'url(' + backgroundImageUrl + ')'}">
      <div class="product-detail-offer-body">
        <div class="left">
          <h2 class="intro-title" [translate]="'eos-tv-shop-ii.title.trial-intro'"></h2>
          <p class="intro-text" [translate]="'eos-tv-shop-ii.text.trial-intro'"></p>
          <div class="trials">
            <div class="no-trials line" *ngIf="!runningTrials || runningTrials.length === 0" [translate]="'eos-tv-shop-ii.text.trial-no-running'"></div>
            <div class="running-trials line" *ngIf="runningTrials.length > 0">
              <span class="title" [translate]="'eos-tv-shop-ii.title.trial-running-sub'"></span>
              <div class="marginTop20">
                <div *ngFor="let trial of runningTrials">
                  <img class="trial-logo {{trial.largeLogo}}" src="{{trial.logoUrl}}"/>
                  <div *ngIf="trial.isTrial">
                    <div class="trial-duration"><span>{{'eos-tv-shop-ii.text.trial-running-duration' | translate}} <strong>{{trial.endDate}}</strong></span></div>
                    <div *ngIf="trial.futureProduct" class="trial-conversion"><span [translate]="'eos-tv-shop-ii.text.trialpage-conversion-from-trial-to-product'" [translateParams]="{packageName: trial.futureProductName}"></span></div>
                  </div>
                  <div *ngIf="trial.isDayPass">
                  <div class="trial-duration"><span>{{'eos-tv-shop-ii.text.daypass-running-duration' | translate}} <strong>{{trial.endDate}}</strong></span></div>
                  <div *ngIf="trial.futureProduct" class="trial-conversion"><span [translate]="'eos-tv-shop-ii.text.trialpage-conversion-from-daypass-to-product'" [translateParams]="{packageName: trial.futureProductName}"></span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="order-links">
            <app-order-button class="order-link smaller"
                              [x]="0"
                              [y]="0"
                              [omapiId]="omapiId"
                              [ownerComponent]="componentName"
                              [isTrial]="true"
                              [buttonTextKey]="'eos-tv-shop-ii.btn.trial-order'"
                              (emitOnEnterPressed)="openTrialActivationModal($event)"
                              (emitOnBack)="onBack()"></app-order-button>
            <app-order-button class="order-link smaller"
                              [x]="1"
                              [y]="0"
                              [omapiId]="omapiId"
                              [ownerComponent]="componentName"
                              [isTrial]="true"
                              [buttonTextKey]="'eos-tv-shop-ii.btn.trial-where-to-find-code'"
                              (emitOnEnterPressed)="openFindTrialModal()"
                              (emitOnBack)="onBack()"></app-order-button>
          </div>
        </div>
        <div class="right">
          <img src="{{trialsVisual}}" class="trials-visual">
        </div>
      </div>
    </div>
  </div>
</div>
<app-trial-modal-manager [runningTrials]="runningTrials" #trialModal></app-trial-modal-manager>
